import { render, staticRenderFns } from "./PocketmagsPlusTemplate.vue?vue&type=template&id=dd09110a&scoped=true"
import script from "./PocketmagsPlusTemplate.vue?vue&type=script&lang=js"
export * from "./PocketmagsPlusTemplate.vue?vue&type=script&lang=js"
import style0 from "./PocketmagsPlusTemplate.vue?vue&type=style&index=0&id=dd09110a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd09110a",
  null
  
)

export default component.exports